import { DEFAULT_MARGIN } from './stylesDefault';

const styles = {
  round: {
    borderRadius: '2em',
    width: '220px',
    height: 'auto',
    maxHeight: '3em',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '8px 16px',
    marginTop: DEFAULT_MARGIN,
    marginBottom: DEFAULT_MARGIN,
  },
};

export default styles;



// WEBPACK FOOTER //
// ./src/constants/KobooRoundButton.css.js